import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Center, Divider, Flex, Text, useMediaQuery, VStack } from '@chakra-ui/react';
import { FT_PI_BOOKING_STEPS_WITH_TITLE } from '@whitbread-eos/api';
import { Icon, Tick, Tick24 } from '@whitbread-eos/atoms';
import { useFeatureToggle } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function BookingFlowSteps(_ref) {
  var steps = _ref.steps,
    activeStep = _ref.activeStep;
  var _useMediaQuery = useMediaQuery('(max-width: 767px)'),
    _useMediaQuery2 = _slicedToArray(_useMediaQuery, 1),
    isMobileView = _useMediaQuery2[0];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFeatureToggle = useFeatureToggle(),
    _useFeatureToggle$FT_ = _useFeatureToggle[FT_PI_BOOKING_STEPS_WITH_TITLE],
    isBookingflowStepTtilesEnabled = _useFeatureToggle$FT_ === void 0 ? false : _useFeatureToggle$FT_;
  return _jsx(Flex, {
    justifyContent: "flex-end",
    sx: {
      '@media print': {
        display: 'none'
      }
    },
    children: _jsxs(VStack, {
      alignItems: "center",
      gap: "xs",
      children: [_jsx(Flex, _objectSpread(_objectSpread({}, progressContainerStyle), {}, {
        "data-testid": "progress-indicator-wrapper",
        children: steps.map((step, index) => _jsxs(Flex, _objectSpread(_objectSpread({}, stepWrapperStyles), {}, {
          "data-testid": "step-container",
          children: [step.id > 1 && _jsx(Divider, _objectSpread(_objectSpread({}, dividerStyles(step.title, isBookingflowStepTtilesEnabled, step.id <= activeStep)), {}, {
            "data-testid": "divider-".concat(index)
          })), _jsxs(Flex, _objectSpread(_objectSpread({}, containerStepStyle), {}, {
            children: [_jsx(Box, _objectSpread(_objectSpread({}, assignBoxStyles(step.id, activeStep, isBookingflowStepTtilesEnabled)), {}, {
              children: _jsx(Center, _objectSpread(_objectSpread({
                "data-testid": "disc-".concat(index)
              }, stepIconDiscStyle(isBookingflowStepTtilesEnabled)), {}, {
                children: step.id < activeStep ? _jsx(Icon, {
                  svg: _jsxs(_Fragment, {
                    children: [_jsx(Box, {
                      display: {
                        mobile: 'none',
                        sm: 'block'
                      },
                      children: _jsx(Tick24, {
                        color: "var(--chakra-colors-baseWhite)",
                        "data-testid": "progress-indicator-icon"
                      })
                    }), _jsx(Box, {
                      display: {
                        mobile: 'block',
                        sm: 'none'
                      },
                      children: _jsx(Tick, {
                        color: "var(--chakra-colors-baseWhite)",
                        "data-testid": "progress-indicator-icon"
                      })
                    })]
                  })
                }) : _jsx(Text, _objectSpread(_objectSpread({}, assignStepStyles(step.id, activeStep)), {}, {
                  children: step.id
                }))
              }))
            }), step.id), step.title && isBookingflowStepTtilesEnabled && _jsx(Text, _objectSpread(_objectSpread({
              "data-testid": "progress-indicator-title"
            }, assignTitleStyles(step.id, activeStep)), {}, {
              children: step.title
            }))]
          }))]
        }), step.id))
      })), isMobileView && isBookingflowStepTtilesEnabled && renderActiveStepSummary(steps, activeStep, t)]
    })
  });
}
function renderActiveStepSummary(steps, activeStep, t) {
  var active = steps.find(s => s.id === activeStep);
  if (!active) {
    return null;
  }
  return _jsxs(Flex, {
    alignItems: "center",
    "data-testid": "active-step-summary",
    children: [_jsx(Text, {
      fontSize: "sm",
      lineHeight: "1",
      color: "darkGrey1",
      children: t('bookingflow.step.now.label')
    }), active.title && _jsx(Text, {
      pl: "2px",
      fontSize: "sm",
      lineHeight: "1",
      color: "darkGrey1",
      fontWeight: "semibold",
      children: active.title
    })]
  });
}
function getStepSizeStyles(isBookingflowStepTtilesEnabled) {
  return isBookingflowStepTtilesEnabled ? {
    h: {
      mobile: 'var(--chakra-space-lg)',
      sm: 'var(--chakra-space-lg)'
    },
    w: {
      mobile: 'var(--chakra-space-lg)',
      sm: 'var(--chakra-space-lg)'
    }
  } : {
    h: {
      mobile: 'var(--chakra-space-lg)',
      sm: 'var(--chakra-space-xl)'
    },
    w: {
      mobile: 'var(--chakra-space-lg)',
      sm: 'var(--chakra-space-xl)'
    }
  };
}
function assignBoxStyles(currentIndex, activeStep, isBookingflowStepTtilesEnabled) {
  var baseStyles = {
    borderRadius: 'full',
    bgColor: activeStep === currentIndex && 'darkGrey1' || activeStep > currentIndex && 'primary' || 'lightGrey4'
  };
  return _objectSpread(_objectSpread({}, baseStyles), getStepSizeStyles(isBookingflowStepTtilesEnabled));
}
var stepIconDiscStyle = getStepSizeStyles;
function assignStepStyles(currentIndex, activeStep) {
  return {
    color: activeStep === currentIndex ? 'baseWhite' : 'darkGrey2',
    fontSize: {
      mobile: 'sm',
      sm: 'md'
    },
    fontWeight: 'medium'
  };
}
function assignTitleStyles(steId, activeStep) {
  return {
    display: {
      mobile: 'none',
      md: 'block'
    },
    pt: 'var(--chakra-space-sm)',
    fontSize: 'sm',
    lineHeight: '1',
    whiteSpace: 'nowrap',
    fontWeight: steId <= activeStep ? 'semibold' : 'normal',
    color: steId <= activeStep ? 'darkGrey1' : 'darkGrey2'
  };
}
var dividerStyles = (title, isBookingflowStepTtilesEnabled, isTicked) => {
  return {
    orientation: 'horizontal',
    bgColor: isTicked ? 'var(--chakra-colors-primary)' : 'lightGrey4',
    h: isTicked ? '2px' : '1px',
    mx: {
      mobile: 'var(--chakra-space-sm)',
      lg: 'var(--chakra-space-md)'
    },
    w: {
      mobile: '6px',
      sm: 'var(--chakra-space-3xl)'
    },
    mb: {
      md: title && isBookingflowStepTtilesEnabled ? 'lg' : ''
    }
  };
};
var progressContainerStyle = {
  justifyContent: 'flex-end',
  alignItems: 'center',
  flexDir: 'row'
};
var containerStepStyle = {
  flexDir: 'column',
  justifyContent: 'center',
  alignItems: 'center'
};
var stepWrapperStyles = {
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center'
};